// src/utils/errorHandler.ts

export interface BackendErrorResponse {
  code?: string;
  message: string;
  args?: any[];
}

export interface CustomError extends Error {
  message: string;
  code?: string;
  args?: any[];
}

export function extractErrorMessage(error: any): CustomError {
  const customError: CustomError = new Error(
    'Something went wrong',
  ) as CustomError;

  console.log('extract error:', error);
  if (!error.response) {
    // Network or CORS error
    customError.message =
      'Network error, please check your internet connection or try again later';
    return customError;
  }

  const { status, data } = error.response;

  switch (status) {
    case 500:
      customError.message = 'Server error, please try again later';
      break;
    case 401:
      customError.message = 'Unauthorized access. Please log in again.';
      break;
    case 403:
      customError.message =
        'Forbidden. You do not have access to this resource.';
      break;
    default:
      if (data) {
        if (typeof data === 'object' && 'message' in data) {
          const backendError = data as BackendErrorResponse;
          customError.message = backendError.message;
          if (backendError.code) {
            customError.code = backendError.code;
          }
          if (backendError.args) {
            customError.args = backendError.args;
          }
        } else if (typeof data === 'string') {
          customError.message = data;
        }
      }
      break;
  }

  return customError;
}
